import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { SubmissionLogTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();
  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <SubmissionLogTab
        advisoryOrganizationId={params.advisoryOrganizationId}
        mode='org'
      />
    </Stack>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/submission-log'
)({
  component: Page
});
